export interface WelcomeBackActions {
  /** «Забрать всё»: офлайн-доход и, если можно, награда серии (I2). */
  claimWelcomeBack(claim: { offline: boolean; streak: boolean }): void;
}

const noop = () => {};

export const defaults: WelcomeBackActions = {
  claimWelcomeBack: noop,
};

declare module "../actions" {
  interface WindowActions extends WelcomeBackActions {}
}
